import React from 'react';
import { useCopyRights } from 'hooks/useCopyRights';
import { useConfigs } from '../configs';
import less from './index.module.less';
import { useLocale } from 'locales/I18N';
import LogoImg from 'assets/img/logo.png';

const Footer: React.FC = () => {
    const copyRights = useCopyRights();
    const configs = useConfigs();
    const { locale } = useLocale();

    return (
        <>
            <div className={less.footer}>
                <div className={less.footerContent}>
                    <div className={less.footerContentItem}>
                        <img src={LogoImg} alt="" />
                    </div>
                    {configs.map((config) => {
                        return config.list.map((listItem, index) => {
                            return (
                                // eslint-disable-next-line react/no-array-index-key
                                <div key={`${config.key}-${index}`} className={less.footerContentItem}>
                                    <div className={less.itemTitle}>{index === 0 ? config.title : ''}</div>
                                    {listItem.map((item) => {
                                        return (
                                            <div className={less.itemLink} key={item.key}>
                                                <a
                                                    href={item.link ?? item.linkWithLocale?.[locale]}
                                                    target={config.targetBlank ? '_blank' : undefined}
                                                    rel="noreferrer"
                                                >
                                                    {item.text}
                                                </a>
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        });
                    })}
                </div>
                <div className={less.footerBottom}>{copyRights}</div>
            </div>
        </>
    );
};

export default Footer;
